export interface AvailableIntegration {
  id: string | null
  provider: string
  label: string
  status: 'assignable' | 'connectable'
  categories: string[]
}

export interface IntegrationToolkit {
  slug: string
  name: string
  description: string
  logo: string | null
  categories: string[]
}

interface BaseOrgIntegration {
  id: string
  provider: string
  provider_label: string
  status: string
  logo?: string | null
  admin_management?: { label: string; status_label: string; description: string }
}

export interface BuiltinOrgIntegration extends BaseOrgIntegration {
  kind: 'builtin'
}

export interface ComposioOrgIntegration extends BaseOrgIntegration {
  kind: 'composio'
  logo: string | null
  connected_account_id: string
  account_label: string
  account_alias: string
  app_slug: string
  last_synced_at: string | null
}

export type OrgIntegration = BuiltinOrgIntegration | ComposioOrgIntegration

export const isComposioIntegration = (i: OrgIntegration): i is ComposioOrgIntegration => i.kind === 'composio'
